<app-card-content [border]="false" [headerColor]="true" icon="pi pi-star-fill" title="Especialidades">
    <div card-header>
        <app-botao-acoes [items]="acoes()" [appCan]="roleEspecialidadeCriar" [appCanUf]="pessoa()?.uf" />
    </div>

    <app-custom-table
        [metadata]="metadataTabela"
        [data]="dataTabela()"
        [loading]="loading()"
        [first]="first()"
        [rows]="rows()"
        [totalRecords]="totalRecords()"
        [showExpandButton]="false"
        [useCustomCard]="true"
        [cardColumns]="2"
        (onPageChange)="onPageChange($event)"
    >
        <ng-template pTemplate="card" let-rowData>
            <app-card-container [hoverEfect]="true" (click)="handleRowClick(rowData.source)" class="especialidade-card-item cursor-pointer block h-full">
                <div class="especialidade-card-header">
                    <div class="especialidade-card-title-row">
                        <div class="especialidade-card-tipo-badge">
                            <p-tag [value]="rowData.tipo.value" [rounded]="true" [style]="{ 'background-color': rowData.tipo.color, color: '#ffffff' }"></p-tag>
                        </div>
                        <h3 class="especialidade-card-title" [title]="rowData.especialidade">
                            {{ obterEspecialidadeExibicao(rowData.source) }}
                        </h3>
                    </div>
                    @if (obterAreaAtuacaoExibicao(rowData.source) !== 'N/A') {
                        <div class="especialidade-card-subtitle">
                            <span>{{ obterAreaAtuacaoExibicao(rowData.source) }}</span>
                        </div>
                    }
                </div>

                <div class="especialidade-card-body">
                    <div class="especialidade-card-row">
                        <i class="pi pi-calendar"></i>
                        <span class="especialidade-card-field-value">
                            Data Certificado: <span>{{ obterDataCertificadoExibicao(rowData.source) }}</span>
                        </span>
                    </div>

                    @if (obterRegistroExibicao(rowData.source) !== 'N/A') {
                        <div class="especialidade-card-row">
                            <i class="pi pi-verified"></i>
                            <span class="especialidade-card-field-value">
                                Registro: <span>{{ obterRegistroExibicao(rowData.source) }}</span>
                            </span>
                        </div>
                    }

                    @if (obterLivroFolhaExibicao(rowData.source) !== 'N/A') {
                        <div class="especialidade-card-row">
                            <i class="pi pi-book"></i>
                            <span class="especialidade-card-field-value">
                                {{ obterLivroFolhaExibicao(rowData.source) }}
                            </span>
                        </div>
                    }

                    @if (obterResolucaoExibicao(rowData.source) !== 'N/A') {
                        <div class="especialidade-card-row">
                            <i class="pi pi-file"></i>
                            <span class="especialidade-card-field-value">
                                Resolução: <span>{{ obterResolucaoExibicao(rowData.source) }}</span>
                            </span>
                        </div>
                    }
                </div>
            </app-card-container>
        </ng-template>
    </app-custom-table>

    <p-confirmDialog></p-confirmDialog>
</app-card-content>
